import * as dotenv from 'dotenv'

const VALID_NODE_ENV = ['development', 'production', 'rc', 'staging'] as const
export type EcoplanetNodeEnv = (typeof VALID_NODE_ENV)[number]
export const isValidEnv = (input: string) => VALID_NODE_ENV.includes(input as EcoplanetNodeEnv)

interface Env {
  apiPort: string
  procurementPort: string
  isDev: boolean
  nodeEnv?: EcoplanetNodeEnv
  baseUrl: string
  procurementUrl: string
  novuApplicationId: string
  novuBackendUrl: string
  novuBackendSocketUrl: string
  socketUrl?: string
  socketPath?: string
  retoolUrl?: string
  isPosthogProxyEnabled: boolean
}

// Only call dotenv.config() in Node
if (typeof process !== 'undefined' && process.env) {
  dotenv.config()
}

function getEnv(): Env {
  // Node.js environment (tests)
  const isNode = typeof process !== 'undefined' && process.env

  if (isNode) {
    return {
      apiPort: process.env.VITE_API_PORT ?? '3000',
      procurementPort: process.env.PROCUREMENT_API_PORT ?? '8080',
      isDev: process.env.NODE_ENV === 'development',
      nodeEnv: process.env.NODE_ENV as EcoplanetNodeEnv,
      baseUrl: process.env.VITE_API_BASE_URL ?? '',
      procurementUrl: process.env.VITE_PROCUREMENT_BASE_URL ?? '',
      novuApplicationId: process.env.VITE_NOVU_APPLICATION_IDENTIFIER ?? '',
      novuBackendSocketUrl: process.env.VITE_NOVU_BACKEND_SOCKET_URL ?? '',
      novuBackendUrl: process.env.VITE_NOVU_BACKEND_URL ?? '',
      socketUrl: process.env.VITE_WEBSOCKET_URL ?? undefined,
      socketPath: process.env.VITE_WEBSOCKET_PATH ?? undefined,
      isPosthogProxyEnabled: process.env.VITE_POSTHOG_PROXY_ENABLED === 'true',
    }
  }

  // Browser
  if (typeof import.meta === 'undefined') {
    throw new Error('Neither process.env nor import.meta available - unsupported environment')
  }

  return {
    apiPort: import.meta.env.VITE_API_PORT ?? '3000',
    procurementPort: import.meta.env.PROCUREMENT_API_PORT ?? '8080',
    isDev: import.meta.env.DEV,
    nodeEnv: import.meta.env.MODE as EcoplanetNodeEnv,
    baseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
    procurementUrl: import.meta.env.VITE_PROCUREMENT_BASE_URL ?? '',
    novuApplicationId: import.meta.env.VITE_NOVU_APPLICATION_IDENTIFIER ?? '',
    novuBackendSocketUrl: import.meta.env.VITE_NOVU_BACKEND_SOCKET_URL ?? '',
    novuBackendUrl: import.meta.env.VITE_NOVU_BACKEND_URL ?? '',
    socketUrl: import.meta.env.VITE_WEBSOCKET_URL ?? undefined,
    socketPath: import.meta.env.VITE_WEBSOCKET_PATH ?? undefined,
    retoolUrl: import.meta.env.VITE_RETOOL_URL ?? undefined,
    isPosthogProxyEnabled: import.meta.env.VITE_POSTHOG_PROXY_ENABLED === 'true',
  }
}

export const env = getEnv()
